import React from 'react';
import MobileSliderPagesWrapper from '../../components/MobileSliderPagesWrapper';
import MobileSliderPagesHeader from '../../components/MobileSliderPagesHeader';
import PrivacyPolicy from '../../../../../modules/Docs/PrivacyPolicy';

function SlideMobilePrivacyPolicy() {
    return <MobileSliderPagesWrapper>
        <MobileSliderPagesHeader goBack />
        <PrivacyPolicy />
    </MobileSliderPagesWrapper>;
}

export default SlideMobilePrivacyPolicy;
